import {
  EscHotKeyIcon,
  ReturnHotKeyIcon,
} from '@modules/common/components/HotKeyIcons';
import { useHotkey } from '@modules/common/hooks';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import { Button, Divider, IconButton, Stack, Typography } from '@mui/material';
import { FormEvent } from 'react';

interface AddPredictionFormProps {
  onCancel: () => void;
  displayName: string;
  onSubmit: (event?: FormEvent<HTMLFormElement> | KeyboardEvent) => void;
  children: React.ReactNode;
}

export const AddPredictionForm = ({
  onCancel,
  displayName,
  onSubmit,
  children,
}: AddPredictionFormProps) => {
  useHotkey({
    hotkey: 'Escape',
    onHotkey: onCancel,
  });

  useHotkey({
    hotkey: 'Enter',
    onHotkey: (event) => onSubmit(event),
  });

  return (
    <Stack px={1.5} py={1} spacing={2}>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton size="small" onClick={onCancel}>
            <KeyboardArrowLeftRoundedIcon
              sx={{
                color: 'text.secondary',
              }}
              fontSize="small"
            />
          </IconButton>
          <Typography variant="subtitle2">Add "{displayName}"</Typography>
        </Stack>
      </Stack>
      <Divider />
      {children}
      <Divider />
      <Stack
        direction="row"
        component="form"
        spacing={1}
        justifyContent="flex-end"
        onSubmit={onSubmit}
      >
        <Button
          variant="outlined"
          onClick={onCancel}
          endIcon={<EscHotKeyIcon />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          type="submit"
          endIcon={<ReturnHotKeyIcon />}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
